<template>
	<div class="news-banner">
    <el-carousel trigger="click" height="400px" indicator-position="none" v-if="bannerList.length>0">
      <el-carousel-item v-for="(item,index) in bannerList" :key="index">
        <div class="banner-item" :style="'background:url('+commenUrl+item+') no-repeat center;background-size: 100% 100%;'">
          <h2 :style="'color:'+themeColor">{{bannerObject.mc}}</h2>
          <p :style="'color:'+themeColor">{{bannerObject.js}}</p>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script setup>
import {reactive,ref, getCurrentInstance, onMounted, watch} from "vue";
import { Search,Menu,Expand } from '@element-plus/icons-vue'
import { useRouter,useRoute } from 'vue-router';
const props = defineProps({
  themeColor: {
    type: String,
    default: '#191919'
  }
})
const route=useRoute();
const router=useRouter();
const {proxy}= getCurrentInstance();
console.log(route)
let path=route.fullPath.split("/")[1];
if(path.indexOf("&")&&route.path=='/newsList'){
  path=path.split("&")[0]
}
const bannerObject=ref({});
const bannerList=ref([]);
function getArticleList(){
  proxy.$request({
    url:"N_QPSTZX_BANNERTGL_BANNERTGL",
    data:{
      "ly":path
    },
    method: "post",
  }).then((res)=>{
    if(res.data.code=="000"){
      let result=res.data.result;
      if(result&&result.length>0){
        bannerObject.value=result[0];
        bannerList.value=bannerObject.value.tp.split(",");
      }
    }
  }).catch((err)=>{
    console.log(err)
  })
}
getArticleList();

watch(()=>route.fullPath,(newValue,oldValue)=>{
  if(newValue){
    path=newValue.split("/")[1];
    getArticleList();
  }
});
</script>


<style lang="less">
.news-banner{
  width: 100%;
  height: 400px;
  text-align: center;
  .banner-item{
    width: 100%;
    height: 400px;
  }
  h2{
    padding-top: 139px;
    font-family: AlibabaPuHuiTi_2_85_Bold;
    font-size: 46px;
    line-height: 65px;
    margin-bottom: 20px;
  }
  p{
    font-family: AlibabaPuHuiTi_2_55_Regular;
    font-size: 24px;
    line-height: 33px;
  }
}
@media (max-width: 768px) {
    .news-banner{
        padding-top: 110px;
    }
}
</style>